import { render, staticRenderFns } from "./EternityPointsHeader.vue?vue&type=template&id=30258bd0&scoped=true"
import script from "./EternityPointsHeader.vue?vue&type=script&lang=js"
export * from "./EternityPointsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30258bd0",
  null
  
)

export default component.exports